define('home/templates/settingsApps',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "<div class=\"fieldset\" role=\"group\" data-role=\"app-field\">\n<div class=\"fieldset__label align__item text-gray\">"
    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "</div>\n<div class=\"fieldset__block align__item\">\n<div class=\"fieldset__block--button\">\n<button class=\"button button-fill--brand text-medium\" data-action='revoke-app' data-app-id='"
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "'>"
    + alias2(helpers.gettext.call(depth0 != null ? depth0 : {},"Revoke Access",{"name":"gettext","hash":{},"data":data}))
    + "</button>\n</div>\n</div>\n</div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "<p class=\"form-description text-gray text-medium\">"
    + container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"You haven't given access to any applications yet.",{"name":"gettext","hash":{},"data":data}))
    + "</p>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<div class=\"form\">\n<div class=\"form__header--mobile visible-md\">\n<a href=\"/home/settings/\" class=\"form__header--mobile-back\"><span class=\"icon-left-bracket\"></span></a>\n<h2>"
    + alias2(helpers.gettext.call(alias1,"Apps",{"name":"gettext","hash":{},"data":data}))
    + "</h2>\n</div>\n<div class=\"form__header\">\n<h1 class=\"form-heading hidden-md\">"
    + alias2(helpers.gettext.call(alias1,"Apps",{"name":"gettext","hash":{},"data":data}))
    + "</h1>\n<p class=\"form-description text-gray text-medium\">"
    + alias2(helpers.gettext.call(alias1,"Control what apps can access your %(Disqus)s account.",{"name":"gettext","hash":{"Disqus":"Disqus"},"data":data}))
    + "</p>\n</div>\n<div class=\"form__content\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.items : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "</div>\n</div>\n";
},"useData":true})

});
